import React, { useState } from 'react';
import { ChevronsUpDown, Check } from 'lucide-react';
import { useRetreatEvent } from '../contexts/EventContext';

interface EventSelectorProps {
    onSelect?: () => void;
}

export const EventSelector: React.FC<EventSelectorProps> = ({ onSelect }) => {
    const { events, selectedEvent, changeEvent, isLoading } = useRetreatEvent();
    const [isOpen, setIsOpen] = useState(false);

    if (isLoading) return <div className="animate-pulse h-10 w-full bg-gray-100 rounded-lg"></div>;
    if (events.length === 0) return null;

    return (
        <div className="relative group">
            <label className="text-[10px] uppercase text-primary-400 font-bold px-1 mb-1 block tracking-wider">
                Aktuelle Veranstaltung
            </label>

            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between bg-white border border-primary-200 rounded-lg px-3 py-2 text-sm shadow-xs hover:border-primary-300 transition-colors cursor-pointer"
            >
                <span className="truncate font-medium text-charcoal">
                    {selectedEvent ? selectedEvent.name : 'Event wählen'}
                </span>
                <ChevronsUpDown className="w-4 h-4 text-charcoal-400" />
            </button>

            {/* Dropdown Backdrop (click outside to close) */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-10 cursor-default"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                    <div className="p-1 max-h-60 overflow-y-auto">
                        {events.map(event => (
                            <div
                                key={event.id}
                                onClick={() => {
                                    changeEvent(event.id);
                                    setIsOpen(false);
                                    onSelect?.();
                                }}
                                className={`px-3 py-2 rounded-md text-sm cursor-pointer flex items-center justify-between group transition-colors ${selectedEvent?.id === event.id
                                    ? 'bg-primary-50 text-primary-700 font-medium'
                                    : 'text-charcoal-600 hover:bg-gray-50'
                                    }`}
                            >
                                <span className="truncate">{event.name}</span>
                                {selectedEvent?.id === event.id && <Check className="w-3 h-3 ml-2" />}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
